import Vue from 'vue'
import Router from 'vue-router'

import Info from './views/Info.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Info
    },
    {
      path: '/finals',
      name: 'finals',
      component: () => import(/* webpackChunkName: "finals" */ './views/Finals.vue')
    },
    {
      path: '/qualifications',
      name: 'qualifications',
      component: () => import(/* webpackChunkName: "qualifications" */ './views/Qualifications.vue'),
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "qualifications" */ './components/qualifications/Individual.vue')
        },
        {
          path: 'teams',
          component: () => import(/* webpackChunkName: "qualifications" */ './components/qualifications/Teams.vue')
        },
        {
          path: 'mixts',
          component: () => import(/* webpackChunkName: "qualifications" */ './components/qualifications/Mixts.vue')
        }
      ]
    },
    {
      path: '/info',
      name: 'info',
      component: Info
    },
    {
      path: '/participants',
      name: 'participants',
      component: () => import(/* webpackChunkName: "start-list" */ './views/StartList.vue')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
